import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';
import * as $ from 'jquery';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import { LabelType, Options } from '@angular-slider/ngx-slider';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { EncrDecrService } from '../../../../Providers/EncrDecrService';
import * as SurveyEntity from '../page-preview-question/surveyEntity';
import OktaAuth from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

@Component({
  selector: 'app-page-preview-question',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule,
    BsDatepickerModule,
    PopoverModule,
    NgxSliderModule
  ],
  templateUrl: './page-preview-question.component.html',
  styleUrl: './page-preview-question.component.scss',
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PreviewQuestionComponent extends BaseHttpReqRespService implements OnInit {
  private gridApi: any;
  questionPreview!: FormGroup;
  questionPreviewData!: SurveyEntity.Meta;
  question!: SurveyEntity.Question;
  qArray!: any[];
  formArray: FormArray<any> = new FormArray<any>([]);
  orderArray: number[] = [1, 2];
  questionId!: string;
  folderId!: string;
  folderName!: string;
  fromModule!: string;
  sectionId!: number;
  surveyId!: number;
  qSectionId!: number;
  _options!: Options;
  sliderForm!: FormGroup;
  minRange!: number;
  maxRange!: number;
  myAppUrl: string = "";
  minDescription: string = "";
  maxDescription: string = "";
  tickDesc: string = "";
  soptions!: Options;
  defRangeValue: number = 0;
  isMaxCharacterExceed!: boolean;
  QUESTION_ENDPOINT = API_ENDPOINTS.QUESTION;
  public fromPage!: string;
  public searchQuestionCategoryId: number = 0;
  public questionLanguageSettingsList: QuestionLanguageSetting[] = [];
  public newVar: Date | undefined = undefined;
  public bsConfig = {
    containerClass: 'theme-primary', // Bootstrap theme
    dateInputFormat: 'DD/MM/YYYY',
    showWeekNumbers: false
  };
  constructor(
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    private _router: Router,
    public http: HttpClient,
    private EncrDecr: EncrDecrService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    @Inject('BASE_URL') baseUrl: string,
    @Inject('CONFIG_SETTINGS') configSettings: any) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.baseUrl = genSettings[<any>'adminApiUrl'];
    this.apiKey = genSettings[<any>'apiKey'];
    this.myAppUrl = this.baseUrl;
  }




  setValue(row: SurveyEntity.RowdataField, column: SurveyEntity.ColumnField) {
    if (column.controlType == 'Text' || column.controlType == 'Label') {
      let obj1 = row.cellReferences.find((n: any) => n.cellAddress.length > 0 && n.cellAddress[0] == row.rowItemId && n.cellAddress[1] == column.columnItemId);
      if (obj1 != undefined)
        return obj1.value;
      else
        return '';
    }
  }

  setSliderValue(range: SurveyEntity.GradingRangeDetails[]) {
    let minRange = range.reduce((min, p) => p.min < min ? p.min : min, range[0].min);
    let maxRange = range.reduce((max, p) => p.max > max ? p.max : max, range[0].max);
    let minDescription = "";
    let maxDescription = "";
    range.forEach(item => {
      if (item.min === minRange) {
        minDescription = item.rangeDescription;
      }
      if (item.max === maxRange) {
        maxDescription = item.rangeDescription;
      }
    });

    this.minRange = minRange;
    this.minDescription = minDescription
    this.maxRange = maxRange;
    this.maxDescription = maxDescription;

    //return this._options = {
    //  floor: minRange,
    //  ceil: maxRange,
    //  translate: (value: number, label: LabelType): string => {
    //    switch (label) {
    //      case LabelType.Floor:
    //        return '<b>' + minDescription + '- </b> ' + value;
    //      case LabelType.Ceil:
    //        return '<b>' + maxDescription + '- </b> ' + value;
    //      default:
    //        return '' + value;
    //    }
    //  }
    //};

  }


  createQuestions(qs: SurveyEntity.Question[]): FormArray {
    const formArray = new FormArray<any>([]);
    qs.forEach((question) => {
      formArray.push(
        new FormGroup<any>({
          qid: new FormControl(question.qid),
          text: new FormControl(question.text),
          order: new FormControl(question.order),
          defaultValue: new FormControl(question.defaultValue),
          width: new FormControl(question.width),
          slider: new FormControl(),
          matrix: new FormGroup<any>({
            hideRowHeader: new FormControl(question.matrix?.hideRowHeader ?? false),
            rowdataFields: this.intializeRowFields(question.matrix ?? { rowdataFields: [] }),
            columnFields: this.intializeColumnFields(question.matrix ?? { columnFields: [] }),
            columns: this.intializeColumns(question.matrix ?? { columns: [] }),
            headerInnerHTML: new FormControl(this.getmatrixHeaders(question))
          }),
          multipleResponse: new FormControl(question.multipleResponse),
          multipleChoice: this.intializeOptions(question.multipleChoice),
          pickList: this.intializePickList(question.pickList)
        })
      );
    });
    this.formArray = formArray as FormArray<any>;
    return this.formArray;
  }
  intializePickList(picklist: SurveyEntity.PickListItem[]): FormArray {
    const picklistarray = new FormArray<any>([]);
    if (picklist != null) {
      picklist.forEach((item, index) => {
        picklistarray.push(new FormGroup<any>({
          text: new FormControl(item.text),
          value: new FormControl(item.value),
          selected: new FormControl(item.selected),
          displayorder: new FormControl(item.displayorder)
        }));

      });
    }
    return picklistarray as FormArray;
  }
  intializeOptions(arraySource: SurveyEntity.Option[]): FormArray {
    const options = new FormArray<any>([]);
    if (arraySource != null) {
      arraySource.forEach((op, index) => {
        options.push(new FormGroup<any>({
          optionId: new FormControl(op.optionId),
          name: new FormControl(op.name),
          value: new FormControl(op.value),
          selected: new FormControl(op.selected),
          order: new FormControl(op.order),
          hoverText: new FormControl(op.hoverText),
          hideHoverText: new FormControl(op.isShowHoverText)
        }))
      });
    }
    return options as FormArray;
  }
  intializeColumns(matrix: SurveyEntity.Matrix): FormArray {
    const colArray = new FormArray<any>([]);
    matrix.columns.forEach((column: any, index: any) => {
      colArray.push(new FormGroup<any>({
        name: new FormControl(column.name),
        childColumns: new FormControl(column.childColumns),
        colspan: new FormControl(column.colspan)
      }));
    });
    return colArray as FormArray;
  }
  intializeColumnFields(matrix: SurveyEntity.Matrix): FormArray {
    const colArray = new FormArray<FormGroup<any>>([]); // Explicitly type as FormArray<FormGroup<any>>
    if (matrix && Array.isArray(matrix.columnFields)) {
      matrix.columnFields.forEach((columnField: SurveyEntity.ColumnField) => {
        colArray.push(new FormGroup({
          columnHeaderText: new FormControl(columnField.columnHeaderText ?? ''),
          columnType: new FormControl(columnField.columnType ?? ''),
          controlType: new FormControl(columnField.controlType ?? ''),
          defaultValue: new FormControl(columnField.defaultValue ?? ''),
          dataSource: new FormControl(columnField.dataSource ?? ''),
          isEnabled: new FormControl(columnField.isEnabled ?? true),
          order: new FormControl(columnField.order ?? 0),
          min: new FormControl(columnField.min ?? null),
          max: new FormControl(columnField.max ?? null),
          width: new FormControl(columnField.width ?? null)
        }));
      });
    }
    return colArray as FormArray;
  }
  intializeRowFields(matrix: SurveyEntity.Matrix): FormArray {
    const rowArray = new FormArray<any>([]);
    matrix.rowdataFields.forEach((rowField: any, index: any) => {
      rowArray.push(new FormGroup<any>({
        rowItemId: new FormControl(rowField.rowItemId ?? ''),
        rowText: new FormControl(rowField.rowText ?? ''),
        cellReferences: new FormControl(rowField.cellReferences ?? null)
      }));
    });
    return rowArray as FormArray;
  }
  ResetValue() {
    this.sliderForm.reset();
  }

  ngAfterViewChecked() {
    $("select").change(function () {
      if ($(this).val() == "") $(this).css({ color: "#aaa" });
      else $(this).css({ color: "#000" });
    });
  }

  async ngOnInit() {


    this.sliderForm = this.formBuilder.group({
      'defRangeValue': new FormControl(null, null),
    });
    this.route.params.subscribe(params => {
      this.questionId = params['questionId'];
      this.folderId = params['folderId'];
      this.folderName = params['folderName'];
      this.sectionId = params['sectionId'];
      this.surveyId = params['surveyId'];
      this.fromModule = params['fromModule'];
      this.qSectionId = params['qSectionId'];
      this.fromPage = params['fromModule'];
      this.searchQuestionCategoryId = params['searchQuestionCategoryId'];
    });
    //this.getAllLanguageSettings();
    await this.http.post<QuestionLanguageSetting[]>(this.myAppUrl + "/" + this.QUESTION_ENDPOINT.LANGUAGE_SETTINGS, '',
      {
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      }).toPromise().then(data => {
        this.questionLanguageSettingsList = data!;
      });


    await this.http.post<SurveyEntity.Meta>(this.myAppUrl + '/' + this.QUESTION_ENDPOINT.PREVIEW, '', {
      params: { 'questionId': this.questionId, }
    }).toPromise().then(data => {
      this.questionPreviewData = data!;
      this.question = this.questionPreviewData.metaBody.sections[0].questions[0];
      //this.tmpQuestion = this.questionPreviewData.metaBody.sections[0].questions[0];
      if (this.question.matrix != null) {
        this.question.matrix.headerInnerHTML = this.getmatrixHeaders(this.question);
      }


      //Get the language settings for this question
      var i1 = 0;

      let questionLanguageSettings: QuestionLanguageSetting[] = [];
      if (this.question && this.question.qid && Array.isArray(this.questionLanguageSettingsList)) {
        questionLanguageSettings = this.questionLanguageSettingsList.filter(
          x => x.questionId === this.question.qid
        );
      }
      questionLanguageSettings.forEach((qls, i) => {

        if (qls.entityTypeText.toLowerCase() === 'question text') {
          //This is for the question text
          this.question.text = qls.languageText;
        }
        if (qls.entityTypeText.toLowerCase() === 'option text') {
          var option: any = undefined;
          if (this.question.type.toLowerCase() === 'multipleresponse') {
            option = this.question.multipleResponse.find((x: any) => x.optionId === qls.entityId);
            if (option) {
              option.name = qls.languageText;
            }
          }
          if (this.question.type.toLowerCase() === 'multiplechoice') {
            option = this.question.multipleChoice.find((x: any) => x.optionId === qls.entityId);
            if (option) {
              option.name = qls.languageText;
            }
          }
          if (this.question.type.toLowerCase() === 'picklist') {
            option = this.question.pickList.find((x: any) => x.value === qls.entityId);
            if (option) {
              option.text = qls.languageText;
            }
          }
          if (this.question.type.toLowerCase() === 'rankingsort') {
            option = this.question.rankingSort.find((x: any) => x.optionId === qls.entityId);
            if (option) {
              option.name = qls.languageText;
            }
          }
          if (this.question.type.toLowerCase() === 'slider') {
            option = this.question.slider.find((x: any) => x.rangeId === qls.entityId);
            if (option) {
              option.rangeDescription = qls.languageText;
            }
          }

        }
        if (qls.entityTypeText.toLowerCase() === 'column item text') {
          var columnItem = this.question.matrix.columnFields.find((x: any) => x.columnItemId === qls.entityId);
          this.question.matrix.columns[i1].childColumns[0] = qls.languageText;

          i1++;
          if (columnItem) {
            columnItem.columnHeaderText = qls.languageText;
          }

          var question = this.question;
        }
        if (qls.entityTypeText.toLowerCase() === 'row item text') {
          var rowItem = this.question.matrix.rowdataFields.find((x: any) => x.rowItemId === qls.entityId);
          if (rowItem) {
            rowItem.rowText = qls.languageText;
          }
        }

      });

      if (this.question.type.toLowerCase() === 'matrix') {
        var question = this.question;
        var matrixHeaders = this.getmatrixHeaders(this.question);
        this.question.matrix.headerInnerHTML = matrixHeaders;
      }

      if (this.question.slider != null) {
        this.setSliderValue(this.question.slider);
        let tmpArray = this.question.slider;
        this.defRangeValue = this.question.defaultValue;
        this.soptions = {
          floor: this.minRange,
          ceil: this.maxRange,
          showTicks:true,
          translate: (value: number, label: LabelType): string => {
            switch (label) {
              case LabelType.Floor:
                return '<b>' + this.minDescription + ': </b> ' + value;
              case LabelType.Ceil:
                return '<b>' + this.maxDescription + ': </b> ' + value;
              default:
                tmpArray.forEach(item => {
                  if (value >= item.min && value <= item.max) {
                    this.tickDesc = item.rangeDescription;
                  }
                });
                return '<b>' + this.tickDesc + ': </b> ' + value;
            }
          }
        };

      }
    });
  }


  getAllLanguageSettings() {
    this.http.post<QuestionLanguageSetting[]>(this.myAppUrl + '/' + this.QUESTION_ENDPOINT.LANGUAGE_SETTINGS, '',
      {
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      }).subscribe(data => {
        this.questionLanguageSettingsList = data;
      });
  }

  getChecked(row: SurveyEntity.RowdataField, column: SurveyEntity.ColumnField) {
    if (this.getIndex(row, column) > -1) {
      return row.cellReferences[this.getIndex(row, column)].value === 'True';
    }
    return false;
  }
  getIndex(row: SurveyEntity.RowdataField, column: SurveyEntity.ColumnField) {
    let index = row.cellReferences.findIndex((n: any) => n.cellAddress.length > 0 && n.cellAddress[0] == row.rowItemId && n.cellAddress[1] == column.columnItemId);
    return index;
  }
  BackUrl() {
    var location = window.location.pathname;
    if (location.includes("/clientadmin") == false) {
      if (this.fromModule == "survey") {
        this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.surveyId, 'sectionId': this.sectionId } });
        localStorage.setItem("qSectionId", this.EncrDecr.set(this.qSectionId.toString()))
      }
      else if (this.fromModule == "Search") {
        this._router.navigate(['/questionSearch'], { queryParams: { searchQuestionCategoryId: this.searchQuestionCategoryId } });
      }
      else {
        if (this.folderId == "0")
          this._router.navigate(['question']);
        else
          this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
      }
    }
    else {
      this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.surveyId, 'sectionId': this.sectionId } });
    }
  }

  initQuestion() {
    return new FormGroup({
      questionTitle: new FormControl(''),
      questionType: new FormControl('', Validators.required),
      options: new FormArray([
        this.initOptions()
      ])
    });
  }

  initOptions() {
    return new FormGroup({
      optionTitle: new FormControl('')
    });
  }
  getQuestions(form: any) {
    //console.log(form.controls.questions.controls);
    return form.controls.questions.controls;
  }
  getOptions(form: any, i: any, j: any) {
    //console.log(form.get('options').controls);
    return form.controls.sections.controls[i].controls.questions.controls[j].controls.multipleResponse.value;

  }

  onSubmit(form: any) {

  }

  //loadHeaders(htmlStr: string, section: number, question: SurveyEntity.Question) {
  //  if ($("#0_" + question.qid).find('thead tr').length == 0) {
  //    $("#0_" + question.qid).find('thead').append(htmlStr);
  //  }
  //}
  loadHeaders(htmlStr: string, section: number, question: SurveyEntity.Question) {
    const tableId = "0_" + question.qid;
    const table = document.getElementById(tableId);
    if (table) {
      const thead = table.querySelector('thead');
      if (thead) {
        const trCount = thead.querySelectorAll('tr').length;
        if (trCount === 0) {
          // Create a temporary <table> to parse the HTML string as table rows
          const tempTable = document.createElement('table');
          tempTable.innerHTML = `<thead>${htmlStr.trim()}</thead>`;
          const tempThead = tempTable.querySelector('thead');
          if (tempThead) {
            Array.from(tempThead.children).forEach(child => {
              if (child.tagName.toLowerCase() === 'tr') {
                this.renderer.appendChild(thead, child);
              }
            });
          }
        }
      }
    }
  }
  getmatrixHeaders(question: SurveyEntity.Question): string {
    let matrixHeaders: string = '';
    const columns = question.matrix.columns;
    if (Array.isArray(columns) && columns.length > 0) {
      const colspan = Math.max(...columns.map(col => col.colspan || 0));
      columns.forEach((value, index) => {
        if (index === 0 && value.colspan > 0) {
          matrixHeaders = "<tr>";
          if (!question.matrix.hideRowHeader) {
            matrixHeaders = matrixHeaders.concat("<th style='min-width:60Px!important'></th>");
          }
        }
        if (value.colspan > 0) {
          matrixHeaders = matrixHeaders.concat(
            "<th style='min-width:60Px!important' colspan='" + value.colspan + "'> <label class='form-control-label'>" + value.name + "</label></th>"
          );
        } else {
          matrixHeaders = matrixHeaders.concat(
            "<th style='min-width:60Px!important' rowspan='" + colspan + "'><label class='form-control-label'>" + value.name + "</label></th>"
          );
        }
        if ((columns.length === (index + 1))) {
          matrixHeaders = matrixHeaders.concat("</tr>");
        }
      });
      const childrenCols = columns.filter(x => x.colspan > 0);
      childrenCols.forEach((value: any, index: any) => {
        if (index === 0) {
          matrixHeaders = matrixHeaders.concat("<tr>");
          if (!question.matrix.hideRowHeader) {
            matrixHeaders = matrixHeaders.concat("<td></td>");
          }
        }
        value.childColumns.forEach((cValue: any) => {
          matrixHeaders = matrixHeaders.concat(
            "<th style='min-width:60Px!important'> <label class='form-control-label'>" + cValue + "</label></th>"
          );
        });
        if ((index + 1) === childrenCols.length) {
          matrixHeaders = matrixHeaders.concat("</tr>");
        }
      });
    } else {
      const columnHeaderData = question.matrix.columnFields;
      if (question.matrix.hideRowHeader) {
        matrixHeaders = "<tr>";
      } else {
        matrixHeaders = "<tr><th style='min-width:60Px!important'></th>";
      }
      columnHeaderData.forEach((header: any) => {
        if (header.width > 0 && header.width !== undefined && header.width !== null) {
          matrixHeaders = matrixHeaders.concat(
            "<th style='min-width:60Px!important;width: " + header.width + "px;padding: 0;white-space: pre-line'><label class='form-control-label'>" + header.columnHeaderText + "</label></th>"
          );
        } else {
          matrixHeaders = matrixHeaders.concat(
            "<th style='min-width:60Px!important'> <label class='form-control-label'>" + header.columnHeaderText + "</label></th>"
          );
        }
      });
      matrixHeaders = matrixHeaders.concat("</tr>");
    }
    return matrixHeaders;

  }

  findTotal(categoryValue: any, params: any) {
    let containsEmptyVal = false;
    let tmpArray: string[] = [];
    // Use HTMLInputElement for value access
    var arr = document.getElementsByName('subCategoryQuantity');
    var tot = 0;
    for (var i = 0; i < arr.length; i++) {
      const input = arr[i] as HTMLInputElement;
      input.style.border = '';
      tmpArray.push(input.value);
      if (parseInt(input.value))
        tot += parseInt(input.value);
    }
    //document.getElementById('total').value = tot;

    if (!tmpArray.includes("")) {
      if (tot != categoryValue) {
        params.target.style.border = "1px solid red";
        return false;
      }
    }

    if (tot <= categoryValue) {
      return true;
    } else {
      params.target.style.border = "1px solid red";
      return false;
    }
  }

  colDefsRankingSort: Array<ColDef | ColGroupDef> = [
    { headerName: 'OptionId', field: 'optionId', hide: true },
    { headerName: '', field: '', width: 20, rowDrag: true, resizable: true },
    { headerName: '', field: 'displayOrder', cellRenderer: this.dropdownRenderer.bind(this), width: 70, resizable: true },
    {
      headerName: '',
      field: 'name',
      width: 700,
      resizable: true,
      tooltipValueGetter: (params: any) => '' + params.value
    },
  ];

  onDragEnd(params: any) {
    let dropdownId = "displayOrder" + "_" + params.node.id;

    let tmpElement = document.getElementById(dropdownId) as HTMLSelectElement;

    this.gridApi.forEachNode(function (node: any) {
      let tmpDDownId = "displayOrder" + "_" + node.id;
      let selectedOptionId = node.data.optionId;
      let optionIndex = node.rowIndex + 1; //node.id;
      let ddElement = document.getElementById(tmpDDownId) as HTMLSelectElement;
      ddElement.options[optionIndex].value = optionIndex;
      ddElement.options[optionIndex].selected = true;
      console.log("node values are:", node.data);
    });

  }

  onKeypressEvent(event: any) {
    var d = event;
    if (event.target.value.length >= event.target.maxLength) {
      this.isMaxCharacterExceed = true;
    } else {
      this.isMaxCharacterExceed = false;
    }
  }
  dropdownRenderer(params: any) {
    this.gridApi = params.api;
    //Find RowIndex   
    var rowIndex = params.rowIndex;
    //create select element using javascript  
    var eSelect = document.createElement("select");
    //Set attributes   
    eSelect.setAttribute('class', 'custom-select form-control');
    eSelect.setAttribute('name', params.colDef.field);
    eSelect.setAttribute('id', params.colDef.field + "_" + rowIndex);
    eSelect.style.width = 78 + "%";
    //get the value of the select option  
    var value = params.data.displayOrder;
    //create the default option of the select element  
    var eOption = document.createElement("option");
    eOption.text = "";
    eOption.value = "";
    eSelect.appendChild(eOption);
    //check field
    if (params.colDef.field == "displayOrder") {
      for (var val of this.question.rankingSort) {
        var eOptionVal = document.createElement("option");
        //Statical set data in grid ComboBox  
        eOptionVal.text = val.displayOrder;
        eOptionVal.value = val.displayOrder;
        eOptionVal.id = val.optionId.toString();
        var customAttr = document.createAttribute("parentId");
        customAttr.value = params.colDef.field + "_" + rowIndex;
        eOptionVal.setAttributeNode(customAttr);
        eSelect.appendChild(eOptionVal);
      }

      this.renderer.listen(eSelect, 'change', (event) => {
        let tmpSelectedVal = event.target.value;
        let selectedId = event.target.id;
        this.gridApi.forEachNode(function (node: any) {
          let tmpDDownId = "displayOrder" + "_" + node.id;
          var dropDownElement = document.getElementById(tmpDDownId) as HTMLSelectElement;
          if (dropDownElement.selectedIndex != -1) {
            var dropdownValue = dropDownElement.options[dropDownElement.selectedIndex].value;
            if (tmpDDownId != selectedId && dropdownValue === tmpSelectedVal) {
              dropDownElement.selectedIndex = -1;
            }
          }
        });
      });

    }
    return eSelect;
  }

  onRankingRowSelected(params: any) {

  }

  onRankingSortGridReady(params: any) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
  }

}

export interface QuestionLanguageSetting {
  mappingId: number;
  questionId: number;
  entityTypeId: number;
  entityId: number;
  languageId: number;
  languageText: string;
  entityTypeText: string;
}
